"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Dr. Aris Thorne",
  quote: "Nexel's G657A2 optical fibers have significantly reduced signal attenuation in our high-density AI data centers. Their precision engineering is unmatched.",
  position: "Chief Technology Officer, Global Connect",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/avatar_dr_thorne.png"
}, {
  author: "Elena Volkov",
  quote: "The integration of Nexel FPV components into our drone systems has increased our flight reliability by 40%. A true leader in high-tech infrastructure.",
  position: "Lead Systems Engineer, SkyBound Robotics",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/avatar_elena_volkov.png"
}, {
  author: "Chen Wei",
  quote: "Their commitment to innovation and technical support has made Nexel our primary partner for next-generation telecom deployments across Asia.",
  position: "VP of Infrastructure, Eastern Networks",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/avatar_chen_wei.png"
}];
export default function ClientTrust() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="41" id="partners" ref={ref} className={cn("dark bg-background text-foreground py-24 transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-sans font-bold tracking-tight text-primary">
            Global Strategic Partners
          </h2>
        </div>

        <div className="mx-auto max-w-4xl">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((item, i) => <CarouselItem key={i} data-index={i} className="md:basis-1/1 lg:basis-1/1">
                  <div className="flex flex-col items-center text-center px-4 md:px-16 py-2">
                    <Quote className="w-12 h-12 text-primary/20 mb-8 rotate-180" />
                    
                    <blockquote className="font-sans text-xl md:text-2xl lg:text-3xl leading-relaxed text-foreground/90 mb-10 italic">
                      &ldquo;{item.quote}&rdquo;
                    </blockquote>

                    <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 mt-2">
                      <SafeHydrate><Avatar className="h-16 w-16 border-2 border-border shadow-lg shadow-primary/5">
                        <AvatarImage src={item.avatar} alt={item.author} />
                        <AvatarFallback className="bg-muted text-muted-foreground text-lg">
                          {item.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="text-center md:text-left">
                        <div className="font-semibold text-lg text-primary">
                          {item.author}
                        </div>
                        <div className="text-sm text-muted-foreground font-mono uppercase tracking-wider">
                          {item.position}
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            {}
            <div className="hidden md:block">
              <CarouselPrevious className="left-0 lg:-left-16 bg-transparent border-border/50 hover:bg-accent hover:text-primary-foreground text-muted-foreground transition-all duration-300" />
              <CarouselNext className="right-0 lg:-right-16 bg-transparent border-border/50 hover:bg-accent hover:text-primary-foreground text-muted-foreground transition-all duration-300" />
            </div>
            
            {}
            <div className="flex justify-center gap-6 mt-12 md:hidden">
               <CarouselPrevious className="static translate-y-0 bg-transparent border-border/50 hover:bg-accent hover:text-primary-foreground text-muted-foreground" />
               <CarouselNext className="static translate-y-0 bg-transparent border-border/50 hover:bg-accent hover:text-primary-foreground text-muted-foreground" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}